<template>
	<div class="department_dv">
		<headdv
		:headTitle="headTitle"
		:isBackShow="true"
		:goPath="goPatHead"
		:activeWebTitle="activeWebTitle"
		></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
		<div class="content_dv_dv">
			<div class="header flex-row">
            <div></div>
				<div class="title">角色管理</div>
				<div class="add" @click="addRights">添加</div>
			</div>
			<div class="content">
				<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" :height="screenHeight-270">
					<el-table-column prop="ar_name" label="角色" width="180"></el-table-column>
					<el-table-column prop="an_ids" label="拥有权限" :formatter="formatter_ar_id"></el-table-column>
					<el-table-column label="操作" width="180">
					<template slot-scope="scope">
						<el-button  size="mini"  class="checkbtn"  @click="handleEdit(scope.row)" >查看</el-button>
						<el-button	class="edit"	size="small"	type="text"		@click="editTangChuan(scope.row)"	>编辑</el-button>
						<el-button size="small"	type="text"		@click.native.prevent="handleDeleteClick(scope.row)" class="del_dv"	>删除</el-button>
					</template>
					</el-table-column>
				</el-table>
			</div>
			<!--分页-->
            <page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
		</div>
      
		</div>
        <!-- 底部 -->
		<footerdv></footerdv>

        <!-- 查看 -->
		<el-dialog :visible.sync="dialogVisible" width="780px;" class="checkDialog add-dv" :close-on-click-modal='false'>
			<div class="title" slot="title">查看</div>
            <div class="dep-name flex-row">
				<label>角色名称:</label>
				<el-input v-model="EidtAccountForm.ar_name" placeholder="请输入角色名称" :disabled="true"></el-input>
			</div>
            <div class="dep-name flex-row">
				<label>角色编码:</label>
				<el-input v-model="EidtAccountForm.ar_code" placeholder="请输入角色编码" :disabled="true"></el-input>
			</div>
			<div class="choose flex-row">
				<div class="txt">所有权限：</div>
				<el-tabs tab-position="left">
				<el-tab-pane v-for="items in NodeListTree" :label="items.an_name" :key="items.id">
					<div class="more-checkbox">
					<el-checkbox-group v-model="checkedAddList" @change="handleCheckedChange">
						<el-checkbox
						disabled
						v-for="item in items.children"
						:label="item"
						:key="item.id"
						:checked="item.checked"
						>{{item.an_name}}</el-checkbox>
					</el-checkbox-group>
					</div>
				</el-tab-pane>
				</el-tabs>
			</div>
		</el-dialog>

		<!-- 添加 -->
		<el-dialog :visible.sync="dialogAddVisible" width="780px;" class="checkDialog add-dv" :close-on-click-modal='false'>
			<div class="title" slot="title">添加</div>
			<div class="dep-name flex-row">
				<label>角色名称:</label>
				<el-input v-model="addAccountForm.ar_name" placeholder="请输入角色名称" ></el-input>
			</div>
            <div class="dep-name flex-row">
				<label>角色编码:</label>
				<el-input v-model="addAccountForm.ar_code" placeholder="请输入角色编码" ></el-input>
			</div>
			<div class="choose flex-row">
				<div class="txt">选择权限：</div>
				<el-tabs tab-position="left">
				<el-tab-pane v-for="items in NodeListTree" :label="items.an_name" :key="items.id">
					<div class="more-checkbox">
                        <el-checkbox-group v-model="checkedAddList" @change="handleCheckedChange">
                            <el-checkbox
                            v-for="item in items.children"
                            :label="item"
                            :key="item.id"
                            :checked="item.checked"
                            >{{item.an_name}}</el-checkbox>
                        </el-checkbox-group>
					</div>
				</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAddVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveBumenFun">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog :visible.sync="isShowEidtForm" width="780px;" class="checkDialog add-dv" :close-on-click-modal='false'>
			<div class="title" slot="title">编辑</div>
			<div class="dep-name flex-row">
				<label>角色名称:</label>
				<el-input v-model="EidtAccountForm.ar_name" placeholder="请输入角色名称"></el-input>
			</div>
            <div class="dep-name flex-row">
				<label>角色编码:</label>
				<el-input v-model="EidtAccountForm.ar_code" placeholder="请输入角色编码"></el-input>
			</div>
			<div class="choose flex-row">
				<div class="txt">选择权限：</div>
				<el-tabs tab-position="left">
				<el-tab-pane v-for="items in NodeListTree" :label="items.an_name" :key="items.id">
					<div class="more-checkbox">
					<el-checkbox-group v-model="checkedAddList" @change="handleCheckedChange">
						<el-checkbox
						v-for="item in items.children"
						:label="item"
						:key="item.id"
						:checked="item.checked"
						>{{item.an_name}}</el-checkbox>
					</el-checkbox-group>
					</div>
				</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShowEidtForm = false">取 消</el-button>
				<el-button type="primary" @click="createAccount_bianji">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="checkDialog add-dv" :close-on-click-modal='false'>
			<div class="title" slot="title">删除</div>
			<!-- 内容区 start-->
			<span>确定删除?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
   data() {
      return {
         screenHeight: document.documentElement.clientHeight ,// 屏幕高度
         activeWebTitle: "设置",
         //分页
         pageData: {
            pagecount: 1, //总页数  ,默认1
            pagesize: 10, //每页多少条  默认10
            pageindex: 1, //当前页  默认1
            count: 1,
         },
         //添加--返回对象
         isShowAddForm: false,
         addAccountForm: {
          ar_name: "",
          ar_code: "",
          an_ids: "",
         },
         //编辑
         isShowEidtForm: false,
         EidtAccountForm: {
            id: "",
            ar_name: "",
            ar_code: "",
            an_ids: "",
         },
         delarr: [], //存放删除的数据
         //删除弹窗
         delDate: {
         title: "删除账号",
         label: "删除数据不可恢复，确定删除？",
         status: false,
         },
      NodeList: [], //  权限数据
      NodeListTree:[],  //树结构-权限
         accountList: [], //部门列表数据
         headTitle: "员工管理",
         goPatHead: "settings",
         tableData: [
         {
            operation: "2016-05-02",
            name: "超级管理员",
            rights:
               "允许添加或删除顾客标签/允许添加或修改顾客名片/允许拉黑/洗白顾客/key{config_customized_appearance} not defined in the dictonary/允许修改客服在线状态/允许邀请访客进行对话/允许转接他人的对话..",
         },
         ],
         dialogVisible: false,
         checkedList: [], //选中的绑定值
         rightsList: [
         {
            name: "访客与对话",
            ids: 1,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: true,
               },
               {
               name: "允许添加或修改顾客名片",
               id: 2,
               checked: true,
               },
               {
               name: "允许拉黑/洗白顾客",
               id: 3,
               checked: true,
               },
               {
               name: "允许修改客服在线状态",
               id: 4,
               checked: true,
               },
               {
               name: "允许邀请访客进行对话",
               id: 5,
               checked: true,
               },
            ],
         },
         {
            name: "历史对话",
            ids: 2,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: true,
               },
            ],
         },
         {
            name: "顾客系统",
            ids: 3,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: true,
               },
            ],
         },
         ],
         dialogAddVisible: false,
         depName: "", //部门名称
         checkedAddList: [],
         addRightsList: [
         {
            name: "访客与对话1",
            ids: 1,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: false,
               },
               {
               name: "允许添加或修改顾客名片",
               id: 2,
               checked: false,
               },
               {
               name: "允许拉黑/洗白顾客",
               id: 3,
               checked: false,
               },
               {
               name: "允许修改客服在线状态",
               id: 4,
               checked: false,
               },
               {
               name: "允许邀请访客进行对话",
               id: 5,
               checked: false,
               },
            ],
         },
         {
            name: "历史对话2",
            ids: 2,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: false,
               },
            ],
         },
         {
            name: "顾客系统3",
            ids: 3,
            children: [
               {
               name: "允许添加或删除顾客标签",
               id: 1,
               checked: false,
               },
            ],
         },
         ],
      };
   },
  created() {
    this.getclasslist_arrid();
    this.getclasslist();
  },
  methods: {
	  	//格式化ids  结果1,1,2,3
		framt_ids_getids_fun(){
			let ids = "";
			for (let i = 0; i < this.checkedAddList.length; i++) {
				if (ids == "") {
					ids = this.checkedAddList[i].id;
				} else {
					ids = ids + "," + this.checkedAddList[i].id;
				}
			}
			return ids
		},
		//格式化ids  结果[] 
	  	framt_idsFun(string){
		    let arr = string.split(",");
			let dataArr = [];
			for (let i = 0; i < arr.length; i++) {
				for (let b = 0; b < this.NodeList.length; b++) {
					if (this.NodeList[b].id == arr[i]) {
						dataArr.push(this.NodeList[b])
					}

				}
			}
			return dataArr
		}, 
		//查看
		handleEdit( row) {
			this.dialogVisible = true;
			this.checkedAddList =  []
            this.checkedAddList = this.framt_idsFun(row.an_ids)
            for(let key in this.EidtAccountForm){
                this.EidtAccountForm[key] = row[key]
            }
		},
	    //点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.isShowEidtForm = true;
			this.checkedAddList =  []
            this.checkedAddList = this.framt_idsFun(row.an_ids)
            for(let key in this.EidtAccountForm){
                this.EidtAccountForm[key] = row[key]
            }
            console.log(this.EidtAccountForm)
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
            let fromData = {
                an_ids : this.framt_ids_getids_fun(),
            }
            for(let key in this.EidtAccountForm){
                if(key != 'an_ids'){
                    fromData[key] =  this.EidtAccountForm[key]
                }
            }
			this.https(this.apiList.updateRole,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.isShowEidtForm = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.id;
			this.delarr.push(id);
			this.delDate.status = true;
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
         let fromData = {
            ids : this.delarr[0],
         }
			this.https(this.apiList.deleteRole, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
    //点击保存
    saveBumenFun() {
        let fromData = {
            an_ids : this.framt_ids_getids_fun(),
        }
        for(let key in this.addAccountForm){
            if(key != 'an_ids'){
               fromData[key] =  this.addAccountForm[key]
            }
        }
		this.https(this.apiList.addRole, fromData).then(
			(response) => {
			if (response.data.code == this.common.code) {
				this.getclasslist();
				//弹窗提示
				this.tc_element(response.data.msg, response.data.code, 2, "添加");
			}
			for(let key in this.addAccountForm){
                this.addAccountForm[key] = ''
            }
			this.dialogAddVisible = false; //隐藏提示框
			}
		);
    },

    //格式化内容--权限id集
    formatter_ar_id(row, column, cellValue, index) {
		if (cellValue == "") return "";
		let arr = cellValue.split(",");
		let ids_name = "";
		for (let i = 0; i < arr.length; i++) {
			for (let b = 0; b < this.NodeList.length; b++) {
			if (this.NodeList[b].id == arr[i]) {
				if (ids_name == "") {
				ids_name = this.NodeList[b].an_name;
				} else {
				ids_name = ids_name + "/" + this.NodeList[b].an_name;
				}
			}
			}
		}
		return ids_name;
    },
    //转树结构
    toTree(data) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item.id] = item;
      });
      data.forEach((item) => {
        let parent = map[item.an_pid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    //获取列表数据--权限
    getclasslist_arrid() {
      var timestamp = Date.parse(new Date());
      this.is_ok = false; //控制帅选请求 一个一个来
      let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&v=${timestamp}`;
      this.https(this.apiList.getNodeList + `${get}`).then((response) => {
        if (response.data.code == this.common.code) {
          this.NodeList = response.data.data; // 列表数据
          this.NodeListTree = this.toTree(response.data.data);
        }
      });
    },
    //获取列表数据--部门列表--也是角色
    getclasslist() {
      this.is_ok = false; //控制帅选请求 一个一个来
      var timestamp = Date.parse(new Date());
      let get = `?pagesize=${this.pageData.pagesize}&pageindex=${this.pageData.pageindex}&v=${timestamp}`;
      this.https(this.apiList.getRoleList + `${get}`).then((response) => {
        if (response.data.code == this.common.code) {
          this.accountList = response.data.data.data; //列表数据
          this.pageData.pagecount = response.data.data.total_page; //总页数
          this.pageData.count = response.data.data.total; //总条数
        }
      });
    },
    goBack() {
      this.$router.go(-1);
	},
	
    handleCheckedChange(value) {
    //   console.log(value);
    },
    addRights() {
        this.dialogAddVisible = true;
        this.checkedAddList = []
        for(let key in this.addAccountForm){
            this.addAccountForm[key] = ''
        }
    },
	//分页
	//pageSize 改变时会触发    每页条数
	handleSizeChange(val) {
		// console.log(val)
		this.pageData.pagesize = val 
		this.getclasslist();
	},
	//currentPage 改变时会触发     当前页
	handleCurrentChange(val) {
		// console.log(val)
		this.pageData.pageindex = val
		this.getclasslist();
	},
  },
};
</script>
<style>
.department_dv .el-table td,
.department_dv .el-table th {
  text-align: center !important;
}

.department_dv .del_dv span {
    margin-left: 15px;
	color: #ec808d;
}
</style>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #f2f2f2;
  justify-content: space-between;
  ::v-deep .el-page-header__left {
    color: #aaaaaa;
  }
  ::v-deep .el-page-header__left::after {
    background-color: transparent;
  }
  .title {
    font-size: 18px;
    color: #4f7da4;
  }
  .add {
    width: 60px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 6px;
    color: #ffffff;
    background: #4f7da4;
    cursor: pointer;
  }
}
.content {
  padding: 20px 0;
  ::v-deep .headrow,
  ::v-deep .headrow th {
    background-color: #f1f4f5 !important;
  }
  .checkbtn {
    border: none;
    color: #4f7da4;
  }
}

// 多选框
::v-deep .el-checkbox-group {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  .el-checkbox {
    margin-bottom: 15px;
  }
}
::v-deep .el-tabs__item.is-active {
  color: #4f7da4;
}
::v-deep .el-tabs__active-bar {
  background-color: #4f7da4;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #4f7da4;
  border-color: #4f7da4;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #4f7da4 !important;
}
// dialog对话框头部和底部样式
.checkDialog {
  .title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
  }
  .el-button--default {
    background: #f2f2f2;
    color: #aaaaaa;
    border: none;
  }
  .el-button--primary {
    background: #4f7da4;
    border: none;
  }
}
// dialog对话框头部和底部样式 - end

// 添加对话框
.add-dv {
  .dep-name {
    margin: 15px 0 10px;
    label {
      width: 74px;
      margin-right: 15px;
    }
  }
  .choose {
    align-items: flex-start;
    .txt {
      height: 40px;
      line-height: 40px;
    }
  }
  ::v-deep .el-tabs__item {
    color: #aaaaaa;
    &.is-active {
      color: #4f7da4 !important;
    }
  }
  ::v-deep .el-input__inner {
    padding-left: 10px;
  }
  ::v-deep .el-checkbox__label {
    color: #aaaaaa;
  }
}
</style>